import { render, staticRenderFns } from "./ModalRecordPlayer.vue?vue&type=template&id=1d52be69"
import script from "./ModalRecordPlayer.vue?vue&type=script&lang=js"
export * from "./ModalRecordPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports